export default __webpack_public_path__ + "static/media/Graph.d90871b6.svg";